import { IonCard, IonCardSubtitle, IonCardTitle, IonIcon, IonItem, IonList, IonPopover } from "@ionic/react";
import "./User.css";
import { useAppSelector } from "../Hooks";
import { selectUser } from "../reducers/UserReducer";
import { useOnlineStatus } from "../utils/useOnlineStatus";
import Logout from "./auth/Logout";
import { isMobile } from "react-device-detect"
import { personCircleOutline } from "ionicons/icons";

const User: React.FC = () => {
  const user = useAppSelector(selectUser);
  useOnlineStatus();
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  if(newUI){

    return <div>
      {isMobile ? <div ><IonIcon id="user-menu"  style={{fontSize:'25px'}} src={personCircleOutline}></IonIcon></div> :
      <IonCard id="user-menu" title="Account" className="user-info" style={{boxShadow:'0px 5px 6px 3px #B0B0B0'}}>
        <IonCardTitle style={{margin:'0.5rem'}}>
          {user?.first_name.toUpperCase()} {user?.last_name.toUpperCase()}
        </IonCardTitle>
      </IonCard>}
      <IonPopover trigger="user-menu" mode='md' triggerAction="click" side='bottom' showBackdrop={false}>
        <IonList>
          <IonItem href="/account?tab=general" >Account</IonItem>
          
        </IonList>
        <IonItem><Logout/></IonItem>
      </IonPopover>
    </div>
  }
  return (
    <IonCard href="/account?tab=general" className="user-info">
      <IonCardTitle className="username" data-testid="menu-username">
        {user?.first_name.toUpperCase()} {user?.last_name.toUpperCase()}
      </IonCardTitle>
      <IonCardSubtitle className="email" data-testid="menu-email">
        {user?.email}
      </IonCardSubtitle>
    </IonCard>
  );
};

export default User;
